export const CACHE_KEY_LIST_EXPORT_ENTITIES = 'exportEntities';
export const CACHE_KEY_EXPORT_ENTITIES = 'exportEntities-one';
export const ROUTE_PATH_EXPORT_ENTITIES = '/configuration/export-entities';
export const TRANSLATION_PREFIX_EXPORT_ENTITIES = 'exportEntities';
export const SECURITY_KEY_EXPORT_ENTITIES = 'EXPORT_ENTITY';

